/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import { IDlvryTileArticleBlockViewProps } from './dlvry-tile-article-block';

export default (props: IDlvryTileArticleBlockViewProps) => {
    const {
        TileArticleBlock,
        linkProps,
        image,
        heading,
        description,
        cta
    } = props;

    return (
        <Module {...TileArticleBlock}>
            <a {...linkProps}>
                <Node className={`${TileArticleBlock.className}__image-wrapper`}>
                    {image}
                </Node>
                <Node className={`${TileArticleBlock.className}__content`}>
                    {heading}
                    {description}
                    {cta}
                </Node>
            </a>
        </Module>
    );
};
